// extracted by mini-css-extract-plugin
module.exports = {"icon":"CheckCouponDialog_icon__1oot_","helper":"CheckCouponDialog_helper__1qu4F"};